// valuesAutoplay.js
const gsap = window.gsap;

export default function initValuesAutoplay(){
  const row = document.querySelector(".values .values__row");
  if (!row) return;

  let tween = null;
  let idleTimer = null;
  let userInteracting = false;
  let lastEnd = 0;

  const MOBILE_MAX = 744;
  const RESUME_IDLE_MS = 1800;
  const SPEED_PX_PER_S = 40;
  const NEAR_EDGE = 2; // px – вважаємо, що дістали краю
  const mqlReduce = window.matchMedia("(prefers-reduced-motion: reduce)");
  const forceAnim = /[?&]anim=1\b/.test(location.search) || document.documentElement.dataset.ignorePrm === '1';

  const getEnd       = () => Math.max(0, row.scrollWidth - row.clientWidth);
  const isMobile     = () => window.innerWidth <= MOBILE_MAX;
  const shouldAutoplay = () => !isMobile() && !(mqlReduce.matches && !forceAnim) && getEnd() > 4;

  // поточний напрямок: 1 — вперед (до end), -1 — назад (до 0)
  let direction = 1;

  function killTween(){
    if (tween) { tween.kill(); tween = null; }
  }

  function distTo(target){
    return Math.max(0, Math.abs(target - row.scrollLeft));
  }

  function tweenTo(target){
    killTween();
    const distance = distTo(target);
    const duration = Math.max(0.2, distance / SPEED_PX_PER_S);

    row.style.scrollBehavior = "auto";
    row.style.overflowX = "hidden";
    row.style.overflowY = "visible";

    tween = gsap.to(row, {
      scrollLeft: target,
      duration,
      ease: "none",
      // ВАЖЛИВО: снап до цілого пікселя
      modifiers: {
        scrollLeft: v => String(Math.round(parseFloat(v)))
        // або швидкий варіант: v => (v|0) + ''
      },
      onComplete: () => {
        if (userInteracting || !shouldAutoplay()) return;
        direction *= -1;
        const end = getEnd();
        tweenTo(direction === 1 ? end : 0);
      }
    });
  }


  function startAutoplay() {
    if (tween || !shouldAutoplay()) return;

    lastEnd = getEnd();
    // Починаємо їхати вперед (до кінця)
    direction = 1;
    tweenTo(lastEnd);
  }

  function stopAutoplay() {
    killTween();
    row.style.overflowX = "";
    row.style.overflowY = "";
    row.style.scrollBehavior = "";
  }

  // «розумне» відновлення: зберігаємо напрямок і швидкість в px/сек
  function resumeAutoplaySmart() {
    if (!shouldAutoplay()) return;

    const end = getEnd();
    lastEnd = end;

    // якщо стоїмо майже на краю — коригуємо напрямок, щоб не «залипати»
    if (row.scrollLeft <= NEAR_EDGE) direction = 1;
    else if (Math.abs(row.scrollLeft - end) <= NEAR_EDGE) direction = -1;

    const target = direction === 1 ? end : 0;
    tweenTo(target);
  }

  const pauseAutoplay  = () => { if (tween) tween.pause();  };
  const clearIdle = () => { if (idleTimer) { clearTimeout(idleTimer); idleTimer = null; } };
  const scheduleResume = () => {
    clearIdle();
    idleTimer = setTimeout(() => {
      userInteracting = false;
      resumeAutoplaySmart();
    }, RESUME_IDLE_MS);
  };

  // force = true — дозволити перескладання, якщо змінився діапазон
  function reevaluate(force = false){
    const end = getEnd();
    const endChanged = Math.abs(end - lastEnd) > 1;

    if (!shouldAutoplay()) {
      stopAutoplay();
      return;
    }
    if (!tween) {
      startAutoplay();
      return;
    }
    if (force && endChanged) {
      // якщо ширина дорожки змінилась — перезапускаємо від поточної позиції
      resumeAutoplaySmart();
      return;
    }
    if (!userInteracting) {
      // звичайне відновлення після дрібних подій
      if (tween.paused()) resumeAutoplaySmart();
    }
  }

  // ---- init
  reevaluate(true);

  // розміри/контент
  const ro = new ResizeObserver(() => reevaluate(true));
  ro.observe(row);

  const mo = new MutationObserver(() => reevaluate(true));
  mo.observe(row, { childList: true, subtree: true });

  window.addEventListener("load", () => reevaluate(true), { once: true });

  if (mqlReduce.addEventListener) mqlReduce.addEventListener("change", () => reevaluate(true));
  else mqlReduce.addListener(() => reevaluate(true));

  // ---- взаємодія користувача
  row.addEventListener("pointerdown", () => {
    userInteracting = true;
    clearIdle();
    pauseAutoplay();
  }, { passive: true });

  row.addEventListener("pointerup", () => { scheduleResume(); }, { passive: true });
  row.addEventListener("pointercancel", () => { scheduleResume(); }, { passive: true });

  row.addEventListener("wheel", () => {
    userInteracting = true;
    clearIdle();
    pauseAutoplay();
    scheduleResume();
  }, { passive: true });

  // hover: пауза → відновлення з сталою швидкістю
  row.addEventListener("mouseenter", () => {
    if (tween && !isMobile()) pauseAutoplay();
  }, { passive: true });

  row.addEventListener("mouseleave", () => {
    if (!userInteracting) resumeAutoplaySmart();
    else scheduleResume();
  }, { passive: true });

  // вкладка
  document.addEventListener("visibilitychange", () => {
    if (document.hidden) pauseAutoplay();
    else reevaluate(true);
  });
}
